import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

type ModuloRegistro = 'medicos' | 'prestadores' | 'orgaos';

@Injectable({
    providedIn: 'root'
})
export class ContextoRotaRegistroService {
    constructor(private router: Router) {}

    ehSistemaRegistro(url?: string): boolean {
        return this.ehRotaModulo('medicos', url) || this.ehRotaModulo('prestadores', url) || this.ehRotaModulo('orgaos', url);
    }

    ehRotaContatosMedico(url?: string): boolean {
        return this.ehRotaItemModulo('medicos', 'contatos', url);
    }

    ehRotaAnotacoesMedico(url?: string): boolean {
        return this.ehRotaItemModulo('medicos', 'anotacoes', url);
    }

    ehRotaItemModulo(modulo: ModuloRegistro, item: string, url?: string): boolean {
        const itemNormalizado = this.normalizarSegmento(item);
        if (!itemNormalizado) {
            return false;
        }

        const caminho = this.normalizarUrl(url);
        const expressao = new RegExp(`^/${modulo}/item/${this.escaparRegex(itemNormalizado)}(?:/|$)`);
        return expressao.test(caminho);
    }

    private ehRotaModulo(modulo: ModuloRegistro, url?: string): boolean {
        const caminho = this.normalizarUrl(url);
        return new RegExp(`^/${modulo}(?:/|$)`).test(caminho);
    }

    private normalizarUrl(url?: string): string {
        const caminho = (url ?? this.router.url ?? '').split('?')[0].trim().toLowerCase();
        if (!caminho) {
            return '/';
        }

        if (caminho !== '/' && caminho.endsWith('/')) {
            return caminho.slice(0, -1);
        }

        return caminho;
    }

    private normalizarSegmento(valor: string): string {
        return (valor || '').trim().toLowerCase().replace(/^\/+/, '').replace(/\/+$/, '');
    }

    private escaparRegex(valor: string): string {
        return valor.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
}
